export const QL1_COLORS = {
  cobalt: '#204080',
  cobaltDeep: '#0A1A33',
  cyan: '#3DAEF5',
  navyInk: '#0E1F3D',
  cream: '#F5F8FC',
  cardLight: '#FFFFFF',
  cardDark: '#15233E',
  inputLight: '#EEF3FA',
  inputDark: '#1A2A48',
  borderLight: '#DCE4F0',
  borderDark: '#22314E',
  fgLight: '#0E1F3D',
  fgDark: '#F2F6FC',
  fgSecondaryLight: '#5A6A82',
  fgSecondaryDark: '#8FA1BE',
  tintWarmLight: '#E5F2FC',
  tintWarmDark: '#102443',
  tintMintLight: '#EAF4FB',
  tintMintDark: '#0F2240',
  tintSageLight: '#EEF1F7',
  tintSageDark: '#172642',
  tintBlueLight: '#E2EDF8',
  tintBlueDark: '#0E2444',
  success: '#31D0AA',
} as const

export const palette = (isDark: boolean) => ({
  bg: isDark ? QL1_COLORS.cobaltDeep : QL1_COLORS.cream,
  card: isDark ? QL1_COLORS.cardDark : QL1_COLORS.cardLight,
  input: isDark ? QL1_COLORS.inputDark : QL1_COLORS.inputLight,
  border: isDark ? QL1_COLORS.borderDark : QL1_COLORS.borderLight,
  fg: isDark ? QL1_COLORS.fgDark : QL1_COLORS.fgLight,
  fgSecondary: isDark ? QL1_COLORS.fgSecondaryDark : QL1_COLORS.fgSecondaryLight,
  cobalt: QL1_COLORS.cobalt,
  cyan: QL1_COLORS.cyan,
  navyInk: QL1_COLORS.navyInk,
  cobaltDeep: QL1_COLORS.cobaltDeep,
  success: QL1_COLORS.success,
  tintTrade: isDark ? QL1_COLORS.tintWarmDark : QL1_COLORS.tintWarmLight,
  tintBridge: isDark ? QL1_COLORS.tintMintDark : QL1_COLORS.tintMintLight,
  tintEarn: isDark ? QL1_COLORS.tintSageDark : QL1_COLORS.tintSageLight,
})
